export const enumFromStringValue = (enm, value) => value && Object.values(enm).includes(value) ? value : undefined;
